<mat-nav-list class="text-center p-16 sposicao_menuebar-tooltip">
  <button
    mat-mini-fab
    color="inherit"
    (click)="toggleCollapsed.emit()"
    class="m-b-16"
  >
    <i class="iconify f-s-24" data-icon="solar:hamburger-menu-line-duotone"></i>
  </button>
  @for(item of getFlattenedItems(menuItems); track item) {
    <mat-list-item
      [class.bg-primary]="item.menu_position === selectedMenu"
      [class.text-white]="item.menu_position === selectedMenu"
      class="menu-list-item p-0 m-b-8"
      (click)="selectIcon(item.menu_position)"
      matTooltip={{item.name}}
      matTooltipPosition="after">
      <i-tabler [name]="item.icon"></i-tabler>
    </mat-list-item>
  }
</mat-nav-list>
